export const LIGHT = 'light';
export const HARD = 'hard';